import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Follow_up_report extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            allovehs: [],
            allovehsl: false,
            headertext:'',
            cushow: false,
            dateofoffloading: '',
            dateofoffloadingt: '',
        }
    }

    async componentDidMount() {
        let type = new URLSearchParams(this.props.location.search).get("type");
        let execute = true;
        let url = "";
        let headertext = "Unknown Type"
        if (type == 1) {
            url = myconfig.report_follow_up_allocated_under_dispatch;
            headertext = "ALLOCATED_UNDER_DISPATCH"
        } else if (type == 2) {
            url = myconfig.report_follow_up_intransit_to_load;
            headertext = "IN_TRANSIT_TO_LOAD_POINT"
        } else if (type == 3) {
            url = myconfig.report_follow_up_waiting_to_load;
            headertext = "WAITING_TO_LOAD"
        } else if (type == 4) {
            url = myconfig.report_follow_up_intransit_to_offload;
            headertext = "IN_TRANSIT_TO_OFFLOAD_POINT"
        } else if (type == 5) {
            url = myconfig.report_follow_up_waiting_to_offload;
            headertext = "WAITING_TO_OFFLOAD"
        } else
            execute = false;
        this.setState({
            headertext: headertext,
        })
        if (execute) {
            this.report_follow_up_intransit_to_load(url);
        }

    }

    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    datemgt = (event,id) => {
        event.preventDefault();
        let url=myconfig.redirectodate_v2+"?id="+id
        const datewindow = window.open(url, "datemgt", "width=500,height=500",true);
    }
    report_follow_up_intransit_to_load = (url) => {
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            allovehs: [],
            allovehsl: false,
            cushow: false,
        })
        axios.post(url, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data)
                this.setState({
                    allovehs: res.data,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    tabledata = () => {
        let count = 0;
        let retdata = null;
        if (this.state.allovehsl) {
            retdata = this.state.allovehs.orders.map(value => {
                let movs = this.state.allovehs.movs.filter(v => {
                    if (v.plateno == value.plate_no)
                        return v;
                })
                let datamovs = movs.map(v2 => {
                    return (<tr>
                        <td>{v2.plateno}</td>
                        <td>{v2.sttime}</td>
                        <td>{v2.stloc}</td>
                        <td>{v2.edtime}</td>
                        <td>{v2.edloc}</td>
                        <td>{v2.dur}</td>
                        <td>{v2.km}</td>
                        <td>{v2.tatloc}</td>
                    </tr>)
                })
                return (
                    <>
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Order</h3>
                            </div>
                            <div className="card-body table-responsive p-2">
                                <table className="table table-head-fixed text-nowrap">
                                    <tr>
                                        <th colSpan={6}><a href="" onClick={(event)=>this.datemgt(event,value.id)}>Date Managment</a></th>
                                    </tr>
                                    <tr>
                                        <th>Order Date</th>
                                        <th>Order #</th>
                                        <th>Customer</th>
                                        <th>Cargo</th>
                                        <th>Orgin</th>
                                        <th>Destination</th>
                                    </tr>
                                    <tr>
                                        <td>{value.orderdate}</td>
                                        <td>{value.order_no}</td>
                                        <td>{value.customer_id}</td>
                                        <td>{value.cargo_id}</td>
                                        <td>{value.org}</td>
                                        <td>{value.des}</td>
                                    </tr>
                                    <tr>
                                        <th>Volume</th>
                                        <th>Sale Type</th>
                                        <th>Type</th>
                                        <th>Transport Rate</th>
                                        <th>Cement Rate</th>
                                        <th>Cement Cost</th>
                                    </tr>
                                    <tr>
                                        <td>{value.volume}</td>
                                        <td>{value.sale_type}</td>
                                        <td>{value.type}</td>
                                        <td>{value.transport_rate_q}</td>
                                        <td>{value.cement_rate_q}</td>
                                        <td>{value.cement_cost}</td>
                                    </tr>
                                    <tr>
                                        <th>Allocation</th>
                                        <th>Arrival @ Load</th>
                                        <th>Loading</th>
                                        <th>Departure</th>
                                        <th>Arrival @ Unload</th>
                                        <th>Offloading</th>
                                    </tr>
                                    <tr>
                                        <td>{value.dateofallocation}</td>
                                        <td>{value.dateofarivalatloadpoint}</td>
                                        <td>{value.dateofloading}</td>
                                        <td>{value.dateofdeparture}</td>
                                        <td>{value.dateofarivalatoffloadpoint}</td>
                                        <td>{value.dateofoffloading}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Movement</h3>
                            </div>
                            <div className="card-body table-responsive p-2">
                                <table className="table table-head-fixed text-nowrap">
                                    <thead>
                                    <tr>
                                        <th>Truck</th>
                                        <th>Start Time</th>
                                        <th>Start Location</th>
                                        <th>End Time</th>
                                        <th>End Location</th>
                                        <th>Duration</th>
                                        <th>Millage</th>
                                        <th>Time at Location</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {datamovs}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                )
            })
        }
        return (<>{retdata}</>)
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        return (
            <>
                <Nav type="follow_up_report"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">{this.state.headertext}</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Follow Report</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="table_search"
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /.card */}
                            </div>
                            <div className="col-12">
                                {this.tabledata()}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Follow_up_report;
